import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Location } from '../../../models/Location';
import { LocationsService } from '../../../services/locations.service';
import * as locsActions from '../actions';

@Injectable()
export class TeacherLocationsEffects {
	getLocationsWithTeachers$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(locsActions.getLocsWithTeachers),
			concatMap((action: any) => {
				return this.locationService.getLocationsWithTeacherHTTP(action.teacher).pipe(
					map((locations: Location[]) => {
						return locsActions.getLocsWithTeachersSuccess({ locs: locations });
					}),
					catchError((error) => of(locsActions.getLocsWithTeachersFailure({ errorMessage: error.message })))
				);
			})
		);
	});

	constructor(private actions$: Actions, private locationService: LocationsService) {}
}
